import moment from "moment/moment";

export const selectTypes = [
  { id: 1, name: "Stocks", label: "t-detailed" },
  { id: 2, name: "Customers", label: "t-total" },
];

export const sortTypes = [
  { id: 0, name: "sort-by-date" },
  { id: 1, name: "sort-by-document-no" },
  { id: 2, name: "sort-by-type" },
];
export const docTypes = [
  { id: -1, name: "all" },
  { id: 1, name: "purchase-invoice" },
  { id: 2, name: "sale-invoice" },
  { id: 3, name: "purchase-invoice-return" },
  { id: 4, name: "sale-invoice-return" },
  { id: 5, name: "external-receipt-voucher" },
  { id: 6, name: "external-exchange-voucher" },
  { id: 7, name: "internal-receipt-voucher" },
  { id: 8, name: "internal-exchange-voucher" },
  { id: 9, name: "opening-stock" },
  { id: 10, name: "daily-entry" },
  { id: 11, name: "opening-entry" },
  { id: 12, name: "sales-switch" },
  { id: 13, name: "shift-closing" },
];
export const selectTypesSearch = [
  { id: 1, name: "Customers", label: "default-account-statement" },
  { id: 2, name: "Stocks", label: "advanced-account-statement" },

];
export const SAdefaultValues = {
  selectType: selectTypes[0],
  selectTypeSearch: selectTypesSearch[0],
  accountMlti:"",
  dateFrom: moment(new Date()).subtract().format("YYYY-MM-DD"),
  dateTo: moment(new Date()).format("YYYY-MM-DD"),
  orderType: sortTypes[0],
  docType: docTypes[0],
  branch: { id: -1, name: "all" },
  center: { id: -1, name: "all" },
  stock: { id: -1, name: "all" },
  account: { id: -1, name: "" },
  omla: { id: -1, name: "all" },
  openBalance: true,
  oldBalance: true,
  type:{id:0, name:'Stocks', label:'all', code:0},
  payType: {id:0, name:'all'},

};
